module.exports = __webpack_public_path__ + "img/bg_logo.40a85e67.jpg";